import './OrderStatusDropdown.scss'
import hash from "object-hash";
import { OrderStatusEnum } from "../../../types/OrderStatusEnum";

import { Title } from "../../Typography";
import Arrow from "../../../assets/caret-down.png";
import { useState } from "react";
import ClickOutside from '../../ClickOutside';

const getStatusText = (orderStatus: OrderStatusEnum) => {
  switch (orderStatus) {
    case OrderStatusEnum.PENDIENTE:
      return "Pendiente";
    case OrderStatusEnum.PROCESSO:
      return "En Proceso";
    case OrderStatusEnum.TERMINADO:
      return "Terminado";
    case OrderStatusEnum.ENTREGADO:
      return "Entregado";
    default:
      return "";
  }
};

const statusOptions = [
  {
    value: OrderStatusEnum.PENDIENTE,
    text: getStatusText(OrderStatusEnum.PENDIENTE),
  },
  {
    value: OrderStatusEnum.PROCESSO,
    text: getStatusText(OrderStatusEnum.PROCESSO),
  },
  {
    value: OrderStatusEnum.TERMINADO,
    text: getStatusText(OrderStatusEnum.TERMINADO),
  },
  {
    value: OrderStatusEnum.ENTREGADO,
    text: getStatusText(OrderStatusEnum.ENTREGADO),
  },
];

export const OrderStatusDropdown = ({ selectedStatus, onChange, disabled }: any) => {
  const [open, setOpen] = useState(false);

  const onChangeSelect = (value: any) => {
    onChange(Number(value));
    setOpen(false);
  };

  const onClickSelect = () => {
    setOpen(!open);
  };

  return (
    <ClickOutside onClickOutside={() => setOpen(false)}>
    <div className={`order-status-dropdown ${disabled && 'disabled'}`}>
      <div className="flex-row" style={{ gap: "5px" }} onClick={onClickSelect}>
        <Title>{getStatusText(selectedStatus)}</Title>
        <img src={Arrow} alt="" />
      </div>

      {open && (
        <div className="options">
          {statusOptions.map((option, index) => (
            <div className={`option ${option.value === selectedStatus ? 'selected' : ''}`} key={hash(option.value)} onClick={() => onChangeSelect(option.value)}>
              {option.text}
            </div>
          ))}
        </div>
      )}
    </div>
    </ClickOutside>
  );
};
